module.exports = "pegasus/assets/themelp1/small/15.png";